import { GET_LEADS_CAP_BRANDS_REQUEST, GET_LEADS_CAP_BRANDS_REQUEST_SUCCESS, GET_LEADS_CAP_BRANDS_REQUEST_FAILURE } from '../../constants/cap.constants';

export const getLeadsCapBrandsRequest = () => ({ type: GET_LEADS_CAP_BRANDS_REQUEST });
export const getLeadsCapBrandsRequestSuccess = payload => ({ type: GET_LEADS_CAP_BRANDS_REQUEST_SUCCESS, payload });
export const getLeadsCapBrandsRequestFailure = error => ({ type: GET_LEADS_CAP_BRANDS_REQUEST_FAILURE, error });



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/actions/cap_actions/get_cap_brands.actions.js